'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

require('../css/MessageBox.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _ExtendedButton = require('./ExtendedButton');

var _ExtendedButton2 = _interopRequireDefault(_ExtendedButton);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

var _utilsLib = require('utils-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
AppURL={me.props.AppURL} 
Title={me.props.TitleMessageNotValidCharacter} 
Message={me.props.MessageNotValidCharacter}

optional:

*/

var MessageBox = function (_Component) {
    _inherits(MessageBox, _Component);

    function MessageBox(props) {
        _classCallCheck(this, MessageBox);

        var _this = _possibleConstructorReturn(this, (MessageBox.__proto__ || Object.getPrototypeOf(MessageBox)).call(this, props));

        _this.state = {};
        _this.state.Open = false;
        _this.state.Message = _this.props.Message;
        _this.state.Title = _this.props.Title;
        _this.state.Field = _this.props.Field;
        return _this;
    }

    _createClass(MessageBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (document) {
                if (document.activeElement) {
                    var aktive = document.activeElement.id;
                    if (aktive) {
                        var docs = document.querySelectorAll('select,input');
                        var maxId = docs.length;
                        var i = void 0;
                        for (i = 0; i <= maxId - 1; i++) {
                            if (docs[i].id === aktive) {
                                docs[i].blur();
                                break;
                            }
                        }
                    }
                }
            }

            this.toggleModal();
            this.setState({});
            var me = this;
            (0, _jquery2.default)(document).keyup(function (e) {
                switch (e.which) {
                    case 27:
                        {
                            //ESC
                            me.Close();
                            break;
                        }
                    default:
                        break;
                }
            });

            var div = document.getElementById("MessageBox");
            div.tabIndex = -1;
            div.focus();

            var kontrastNumber = localStorage.getItem('Kontrast');

            if (kontrastNumber != "10") {
                this.LogoClick();
            }

            this.FontSizeClick();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.modal === true) {
                this.toggleModal();
            }
        }
    }, {
        key: 'toggleModal',
        value: function toggleModal() {
            var modal = document.querySelector(".modalLoadingBox");
            modal.classList.toggle("show-modalLoadingBox");
        }
    }, {
        key: 'Close',
        value: function Close() {
            if (this.props.Click) {
                this.props.Click();
            }

            if (this.state.Field) {
                if (document.getElementById(this.state.Field)) {
                    document.getElementById(this.state.Field).focus();
                }
            }

            if (document.getElementById('pickerContainer')) {
                if (document.getElementById('pickerContainer').children.length === 0) {
                    _reactDom2.default.unmountComponentAtNode(document.getElementById('messageContainer'));
                } else {
                    _reactDom2.default.unmountComponentAtNode(document.getElementById('pickerContainer'));
                }

                (0, _jquery2.default)("#Content").css("opacity", "1");
            } else {
                if (document.getElementById('messageContainer')) {
                    if (document.getElementById('messageContainer').children.length === 0) {
                        _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                    } else {
                        _reactDom2.default.unmountComponentAtNode(document.getElementById('messageContainer'));
                    }
                }
                (0, _jquery2.default)("#Content").css("opacity", "1");
            }
        }
    }, {
        key: 'LogoClick',
        value: function LogoClick() {
            var kontrastNumber = localStorage.getItem('Kontrast');

            if (kontrastNumber == 'true') {
                (0, _jquery2.default)('.MessageBoxTitle').attr('style', 'background-color: #1d5c87;');
                (0, _jquery2.default)('.modalLoadingBox').attr('style', 'background-color: rgba(29, 92, 135, 0.6);');
                (0, _jquery2.default)('#messageBoxExtendedButton').attr('style', 'background-color: #1d5c87; width: 150px; float: right;');
            } else if (kontrastNumber == "false") {
                (0, _jquery2.default)('.MessageBoxTitle').attr('style', 'background-color: #3393d3;');
                (0, _jquery2.default)('.modalLoadingBox').attr('style', 'background-color: rgba(51, 147, 211, 0.6);');
                (0, _jquery2.default)('#messageBoxExtendedButton').attr('style', 'background-color: #3393d3; width: 150px; float: right;');
            }
        }
    }, {
        key: 'FontSizeClick',
        value: function FontSizeClick() {

            var schriftgröße = localStorage.getItem('Schriftgröße');

            //Schriftgröße bei Klick in 2er Schritten erhöhen

            if (schriftgröße != null) {
                switch (schriftgröße) {
                    case "0":
                        (0, _jquery2.default)('.MessageBoxTitle').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                        (0, _jquery2.default)('.MessageBoxMessageContainer').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                        (0, _jquery2.default)('#messageBoxExtendedButton').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                        break;
                    case "1":
                        (0, _jquery2.default)('.MessageBoxTitle').removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                        (0, _jquery2.default)('.MessageBoxMessageContainer').removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                        (0, _jquery2.default)('#messageBoxExtendedButton').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                        break;
                    case "2":
                        (0, _jquery2.default)('.MessageBoxTitle').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                        (0, _jquery2.default)('.MessageBoxMessageContainer').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                        (0, _jquery2.default)('#messageBoxExtendedButton').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                        break;
                    case "3":
                        (0, _jquery2.default)('.MessageBoxTitle').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                        (0, _jquery2.default)('.MessageBoxMessageContainer').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                        (0, _jquery2.default)('#messageBoxExtendedButton').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                        break;
                    case "4":
                        (0, _jquery2.default)('.MessageBoxTitle').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                        (0, _jquery2.default)('.MessageBoxMessageContainer').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                        (0, _jquery2.default)('#messageBoxExtendedButton').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                        break;
                    case "5":
                        (0, _jquery2.default)('.MessageBoxTitle').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                        (0, _jquery2.default)('.MessageBoxMessageContainer').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                        (0, _jquery2.default)('#messageBoxExtendedButton').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                        break;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            this.LogoClick();

            var Style = null;
            var top = null;
            var left = null;
            if (document.getElementById("MessageBox")) {
                top = -(document.getElementById("MessageBox").offsetHeight / 2);
                left = -(document.getElementById("MessageBox").offsetWidth / 2);
            }
            Style = { marginTop: top, marginLeft: left };

            (0, _jquery2.default)("#Content").css("opacity", "0.4");

            var notAllFieldsFilled = localStorage.getItem("NotAllFieldsFilled");

            return _react2.default.createElement(
                'div',
                { className: "modalLoadingBox" },
                _react2.default.createElement(
                    'div',
                    {
                        role: "dialog",
                        id: "MessageBox",
                        className: "MessageBox",
                        style: Style },
                    _react2.default.createElement(
                        'div',
                        { className: "MessageBoxTitle" },
                        this.state.Title ? this.state.Title : _Vas2.default.getText("Titles", "Note"),
                        _react2.default.createElement(_Icon2.default, {
                            Name: "Close",
                            AppURL: this.props.AppURL,
                            Color: "white",
                            Size: 24,
                            Style: { cursor: 'pointer' },
                            Align: "right",
                            OnClick: function OnClick() {
                                _this2.Close();
                            } })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "MessageBoxMessageContainer" },
                        this.state.Message ? this.state.Message : notAllFieldsFilled != null ? notAllFieldsFilled : _Vas2.default.getText('ErrorMessages', 'Error'),
                        ' '
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_ExtendedButton2.default, {
                            Id: "messageBoxExtendedButton",
                            Usable: true,
                            Text: "OK",
                            Width: 150,
                            style: { marginTop: '2px !important' },
                            Float: 'right',
                            OnClick: function OnClick() {
                                _this2.Close();
                            } })
                    )
                )
            );
        }
    }]);

    return MessageBox;
}(_react.Component);

exports.default = MessageBox;